import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const UltraschallPage = () => {
  return (
    <Layout>
      <PageHero
        title="Ultraschall (Sonographie): Schonende Einblicke ins Körperinnere"
        subtitle="Wir nutzen Schallwellen für eine schmerzfreie Darstellung Ihrer inneren Organe."
        backgroundImage="/images/2B4_Ultraschall_Sonographie.webp"
        ctaText="Ultraschall-Termin buchen"
      />

      <ContentSection
        title="Präzise Diagnostik ohne Strahlung"
        content="Die Sonographie ist ein vielseitiges und sicheres bildgebendes Verfahren. Wir setzen Ultraschall ein, um Ihre Bauchorgane (Leber, Gallenblase, Nieren, Bauchspeicheldrüse), die Schilddrüse oder Blutgefäße (z.B. Halsschlagadern) zu untersuchen. Diese Methode ist schmerzfrei und kann jederzeit wiederholt werden."
        image="/images/2B4_Ultraschall_Sonographie.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Ultraschalluntersuchungen in Diez und Limburg"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet umfassende Ultraschalldiagnostik zur Abklärung verschiedener Organe und Gefäße."
      />

      <CTASection
        title="Benötigen Sie eine Ultraschalluntersuchung?"
        subtitle="Vereinbaren Sie jetzt Ihren Termin bei uns."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default UltraschallPage;
